import {Params} from "@angular/router";

/** Відповідь web_api/assistant/status: показувати краплю помічника цьому користувачу */
export interface AssistantStatus {
  enabled: boolean;
}

/** Кнопка-уточнення під відповіддю помічника (команда suggest): напис і що надіслати від клієнта */
export interface AssistantSuggestion {
  text: string;
  send: string;
}

/**
 * Команда вікну чату з відповіді assistant/message (формат - дока maslo-mkdocs assistant_message.md):
 * navigate, set_filter, open_order, show_track_status відкривають сторінку, highlight і refresh_basket виконує відкрита
 * сторінка (обробник AssistantActionsService.register), suggest - кнопки під відповіддю (їх малює вікно чату).
 * anchor - службова: так сервіс передає картці товару якір navigate.
 */
export interface AssistantAction {
  type: string;
  /** navigate, open_order, show_track_status: маршрут кабінету з «/»; highlight: сторінка, на якій підсвітити */
  route?: string;
  /** open_order: сторінка без «/» (orders_history_new, orders_history_nalojki, orders) - те саме, що route */
  page?: string;
  /** open_order: розкрити деталі замовлення (false - лише прокрутити й підсвітити; немає - розкрити) */
  expand?: boolean;
  /** suggest: кнопки під відповіддю */
  options?: AssistantSuggestion[];
  /** navigate (/account), set_filter: пошук і прапорці каталогу */
  query?: Params;
  /** set_filter: фільтри каталогу (бренд, категорія, характеристики) */
  filters?: Params;
  /** navigate на картку товару: куди прокрутити (analogs - блок аналогів) */
  anchor?: string;
  /** highlight: що підсвітити - товари (good, pack_id) чи замовлення (order) */
  target?: string;
  /** highlight: id товарів чи номери замовлень */
  ids?: number[];
  /** open_order, show_track_status: номер замовлення */
  order_id?: number;
  /** open_order, show_track_status: дата замовлення в історії (РРРР-ММ-ДД) - сторінка розширює період, якщо замовлення старше */
  date?: string;
  /** highlight замовлень: дати найстаршого й найновішого з них в історії (РРРР-ММ-ДД) - сторінка розширює період під них */
  date_from?: string;
  date_to?: string;
}

/**
 * Відповідь assistant/message (і тіло 403/429 - там ще error). error not_authorized / user_deleted /
 * site_blocked - сесії вже немає, перехоплювач сам веде на вхід чи службову сторінку.
 */
export interface AssistantReply {
  text?: string;
  actions?: AssistantAction[];
  error?: string;
}

/** Відповідь assistant/reset */
export interface AssistantResetReply {
  success?: boolean;
  error?: string;
  text?: string;
}

/** Повідомлення в історії чату (sessionStorage) */
export interface AssistantMessage {
  role: 'user' | 'assistant';
  text: string;
  /** Не відповідь помічника, а повідомлення вікна про збій (інший вигляд) */
  error?: boolean;
  /** Кнопки-уточнення під відповіддю помічника (команда suggest) - показуються, поки це останнє повідомлення */
  options?: AssistantSuggestion[];
}

/** Шматок тексту повідомлення: звичайний текст або посилання на сторінку кабінету; bold - жирне (**…**, картка #986) */
export interface AssistantTextPart {
  text: string;
  route?: string;
  query?: Params;
  bold?: boolean;
}

/** Рядок відповіді помічника - шматки тексту */
export type AssistantTextLine = AssistantTextPart[];

/**
 * Блок відповіді помічника у вікні (картка #986): абзац, маркований список (list) чи нумеровані кроки (steps).
 * heading - абзац з одного рядка, цілком жирного: заголовок блоку під ним.
 */
export interface AssistantTextBlock {
  type: 'paragraph' | 'list' | 'steps';
  /** paragraph: рядки абзацу */
  lines?: AssistantTextLine[];
  /** list, steps: пункти, у кожного - свої рядки (рядок з відступом під пунктом - продовження пункту) */
  items?: AssistantTextLine[][];
  /** steps: номер першого кроку */
  start?: number;
  heading?: boolean;
}
